import { call, put, takeLatest } from 'redux-saga/effects';
import { impersonateUserRequest } from 'api/InternalAdminAPI';
import { addNegativeToast } from 'modules/toastContainer';
import { addToRootSaga } from 'store';
import { push } from 'redux-first-history';
import { viewAsUserResponse } from 'core/userContext/actions';
import * as userContextActionTypes from 'core/userContext/actionTypes';
import * as actions from './actions';

export function* viewAsUserSaga(email: string) {
  try {
    yield call(impersonateUserRequest, email);
    yield put(viewAsUserResponse());
    yield put(push(`/campaigns`));
    window.location.reload();
  } catch (error: any) {
    yield put(actions.createOrganizationError(error.toString()));
    yield put(
      addNegativeToast(`There was an error loading the new organization. ${error.toString()}.`),
    );
  }
}

addToRootSaga([
  // @ts-ignore
  takeLatest(userContextActionTypes.VIEW_AS_USER_REQUEST, viewAsUserSaga),
]);
